import React from "react";
import styles from './FormikCheckBox.module.scss';
import {FastField} from 'formik';
import {CheckboxWithLabel} from 'formik-material-ui';
import FormErrorDisplay from "../formErrorDisplay/FormErrorDisplay";
import SkeletonPlaceHolder from "../skeletonPlaceHolder/SkeletonPlaceHolder";

export interface IFormikCheckBoxProps {
  loading?: boolean;
  label?: any;
  name?: string;
}

const CheckBox = props => {
  const {onChange, ...field} = props.field;
  const touched = props.form.touched[field.name];
  const error = touched && props.form.errors[field.name];
  return <>
    <CheckboxWithLabel {...props}
                       field={field}
                       className={[styles.CheckBox, ((!error) ? "valid" : "")].join(" ")}
                       onClick={() => props.form.setFieldValue(field.name, !field.value)}
    />
    <FormErrorDisplay error={error} className={styles.errorDisplay}/>
  </>
};

const FormikCheckBox = (props: IFormikCheckBoxProps) => {
  if (props.loading) {
    return (<SkeletonPlaceHolder
      variant="text"
      width={300}
    />);
  } else {
    return (
      <FastField
        type="checkbox"
        component={CheckBox}
        Label={{
          label:
            <span>
              {props.label}
            </span>
        }}
        name={props.name}
        color="primary"
      />
    );
  }
};

FormikCheckBox.defaultProps = {};

export default React.memo(FormikCheckBox);
